import FilterNewTag from "app/pages/sales-intelligence/common-components/filters-panel/components/FilterNewTag/FilterNewTag";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import AdSpendChannelsFilter from "../../components/filters/AdSpendChannelsFilter/AdSpendChannelsFilter";
import AdSpendChannelsFilterResult from "../../components/filters/AdSpendChannelsFilter/AdSpendChannelsFilterResult";
import { AdSpendChannelsUpgradeView } from "../../components/filters/AdSpendChannelsFilter/AdSpendChannelsUpgradeView";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineDescriptionFilter } from "../defineSourcedFilter";

import FindAdSpendChannelsFilter from "./AdSpendChannelsFilter";

export const adSpendChannelsDefinition = defineDescriptionFilter({
    key: "adSpendChannels",
    apiCategory: leadsFilterApiCategory.adSpendChannels,
    category: leadsFilterCategoryMap.advertiserActivity,
    trackingName: "Ad Spend Channels",
    titleKey: { key: "si.lead_gen_filters.ad_spend_channels.name" },

    render: ({ description }) => ({
        tooltipText: { key: "si.lead_gen_filters.ad_spend_channels.tooltip" },
        filter: new FindAdSpendChannelsFilter({
            options: {
                channelShare: description.adIntelligence.displayAdsShare,
            },
        }),
        filterView: AdSpendChannelsFilter,
        filterResultView: AdSpendChannelsFilterResult,
        gateStatus: !salesSettingsHelper.isSIAdIntelligenceEnabled
            ? { type: "upgrade", view: AdSpendChannelsUpgradeView }
            : undefined,
        tag: FilterNewTag,
    }),
});
